module.exports = __webpack_public_path__ + "static/media/lab_background_sm.d8df19fb.jpg";